module.exports = __webpack_public_path__ + "static/img/9.b6b7c7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/9.png
// module id = nYiu
// module chunks = 0